import useUserSettings from "@/composables/useUserSettings";

const { getUserSetting } = useUserSettings();

export default {
    namespaced: true,
    state: {
        soundNotifyConversationUnassigned: getUserSetting("soundNotifyConversationUnassigned", "0"), // Nieuwe inkomende conversaties in 'Nieuw'
        soundNotifyConversationAssigned: getUserSetting("soundNotifyConversationAssigned", "0"), // Wanneer een conversatie aan mij wordt toegewezen
        soundNotifyIncomingMessage: getUserSetting("soundNotifyIncomingMessage", "0"), // Nieuwe reactie op een aan mij toegewezen conversatie
        soundNotifyIncomingMessageNew: getUserSetting("soundNotifyIncomingMessageNew", "0"), // Elke nieuwe reactie van conversaties in 'Nieuw'
        soundNotifyTeamchatStarted: getUserSetting("soundNotifyTeamchatStarted", "0"),
        soundNotifyTeamchatMessage: getUserSetting("soundNotifyTeamchatMessage", "0"),
    },
    getters: {},
    mutations: {
        UPDATE_SOUND_NOTIFY_CONVERSATION_UNASSIGNED(state, val) {
            state.soundNotifyConversationUnassigned = val;
        },
        UPDATE_SOUND_NOTIFY_CONVERSATION_ASSIGNED(state, val) {
            state.soundNotifyConversationAssigned = val;
        },
        UPDATE_SOUND_NOTIFY_INCOMING_MESSAGE(state, val) {
            state.soundNotifyIncomingMessage = val;
        },
        UPDATE_SOUND_NOTIFY_INCOMING_MESSAGE_NEW(state, val) {
            state.soundNotifyIncomingMessageNew = val;
        },
        UPDATE_SOUND_NOTIFY_TEAMCHAT_ASSIGNED(state, val) {
            state.soundNotifyTeamchatStarted = val;
        },
        UPDATE_SOUND_NOTIFY_TEAMCHAT_MESSAGE(state, val) {
            state.soundNotifyTeamchatMessage = val;
        },
    },
};
